import { ArrowBigRight } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '#app/components/ui/button.tsx'
import { MainMenu } from '#app/features/menu/index.tsx'
import { useGlobalChatStore } from '#app/routes/chat+/index.tsx'
import IntakeModal from '../intake-modal/index.tsx'
import PaymentModal from '../payment-modal/index.tsx'

interface MenuBarProps {}

const MenuBar: React.FC<MenuBarProps> = () => {
	const { t } = useTranslation('chat')
	const intakeStatus = useGlobalChatStore(state => state.intakeStatus)

	const intakeIsNotFinished =
		intakeStatus === 'incomplete-all' ||
		intakeStatus === 'incomplete-questions' ||
		intakeStatus === 'incomplete-tests'

	return (
		<div className="hidden w-full flex-row justify-end gap-2 p-2 lg:flex">
			{intakeIsNotFinished && (
				<IntakeModal
					customButton={
						<Button>
							<p className="mr-2">{t('intake.clickHereForIntakeTitle')}</p>
							<ArrowBigRight />
						</Button>
					}
				/>
			)}

			<PaymentModal />
			<MainMenu />
		</div>
	)
}

export default MenuBar
